<script setup lang="ts">
import { LANG } from '../../configs/lang';
import { useLangStore } from '../../stores';
import Button from '../General/Button.vue';

const lang = useLangStore()
</script>

<template>
    <div class="flex flex-wrap items-center justify-center gap-3">
        <Button :color="lang.locale === locale ? 'success' : 'gray'"
            :type="lang.locale === locale ? 'normal' : 'outline'" class="min-w-40"
            v-for="(localeConfig, locale) in LANG" @click="lang.setLocale(locale)">
            <img :src="localeConfig.img_flag" class="size-6" />
            <span>{{ localeConfig.label }}</span>
        </Button>
    </div>
</template>